import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const reviewsContainer = css`
  width: 100%;
  padding-top: var(--space-1000);
  padding-bottom: var(--space-500);

  ${breakpoints.only.tablet} {
    padding-top: var(--space-800);
    padding-bottom: var(--space-450);
  }

  ${breakpoints.only.mobile} {
    padding-top: var(--space-600);
    padding-bottom: var(--space-650);
  }
`;

export const reviewsHeader = css`
  margin-bottom: var(--space-400);

  ${breakpoints.only.mobile} {
    margin-bottom: var(--space-250);
  }
`;

export const reviewsWidget = css`
  position: relative;
  height: 1200px;
  overflow: hidden;
`;

export const reviewsFrame = css`
  box-sizing: border-box;
  width: 100%;
  max-width: 760px;
  height: 100%;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
`;

export const reviewsLink = css`
  position: absolute;
  left: 0;
  bottom: 8px;
  display: block;
  box-sizing: border-box;
  width: 100%;
  max-width: 760px;
  max-height: 14px;
  padding: 0 16px;
  overflow: hidden;
  font-size: 10px;
  font-family:
    YS Text,
    sans-serif;
  white-space: nowrap;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  color: #b3b3b3;
`;
